import { isSupported } from 'firebase/messaging'

import { useAuthStore } from '@/stores/retailer/auth.js'
import { firebaseAppConfig, firebaseVapIdKey } from '@/libraries/firebase/firebaseConfig.js'
import createFirebaseManager from '@/libraries/firebase/firebaseManager.js'
import country from '@/utilities/country.js'

export default {
  install: async app => {
    if (country.isNot('tr')) {
      return
    }

    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      return
    }

    const isSupportedBrowser = await isSupported()
    if (isSupportedBrowser === false) {
      return
    }

    const authStore = useAuthStore()

    const firebaseManager = createFirebaseManager({
      appConfig: firebaseAppConfig,
      vapidKey: firebaseVapIdKey
    })

    firebaseManager.onMessage(payload => {
      const { id, message, url, type } = payload.data

      const notification = {
        id: id,
        type: type,
        message: message,
        url: url
      }

      authStore.addNotification(notification).then(() => {
        authStore.setShowNotificationContainer(true)
      })
    })

    app.provide('firebaseManager', firebaseManager)
  }
}
